import React from "react";
import {createEmptyEditor} from "../factories";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd, faClose} from "@fortawesome/free-solid-svg-icons";
import CustomSelect from "../../../../../../../components/elements/CustomSelect";
import {LANGUAGES} from "../../../../../../../utils/constants";
import InputField from "../../../../../../../components/elements/InputField";
import CodeEditor from "../../../../../../../components/elements/CodeEditor";
import Button from "../../../../../../../components/elements/Button";

export default function StepEditorsManager({editors, path, updateAtPath, referencedIds}) {
    const addEditor = () => {
        updateAtPath(path, [...editors, createEmptyEditor()]);
    };

    const deleteEditor = (index) => {
        const editorId = editors[index].id;
        if (referencedIds.includes(editorId)) {
            alert(`Cannot delete: Editor "${editorId}" is used by a Run Target.`);
            return;
        }
        if (editors.length <= 1) {
            alert("Step must have at least one editor.");
            return;
        }
        updateAtPath(path, editors.filter((_, i) => i !== index));
    };

    return (
        <div className='py-5 px-10 bg-gray-100 rounded-md'>
            <div className='flex justify-between items-center mb-5'>
                <h3 style={{margin: 0}}>Editors</h3>
                <Button onClick={addEditor} className="flex items-center gap-3">
                    <span>Add Editor</span>
                    <FontAwesomeIcon icon={faAdd} size='md' />
                </Button>
            </div>

            <div style={{display: "grid", gap: 8}}>
                {editors.map((ed, idx) => (
                    <div key={ed.id}
                         style={{border: "1px solid #ccc", padding: 8, borderRadius: 4, background: "#fff"}}>
                        <div style={{display: "flex", gap: 8, marginBottom: 8}}>
                            <input
                                style={{flex: 1, fontWeight: "bold"}}
                                value={ed.id}
                                onChange={e => updateAtPath([...path, idx, "id"], e.target.value)}
                                placeholder="Unique Editor ID"
                            />
                            <button
                                type="button"
                                onClick={() => deleteEditor(idx)}
                                style={{color: "red"}}
                            >
                                <FontAwesomeIcon icon={faClose} size={'md'}/>
                            </button>
                        </div>

                        <div className='flex items-center p-5 gap-5 flex-1'>
                            <CustomSelect value={ed.language}
                                          className='flex flex-1'
                                          options={LANGUAGES}
                                          onChange={e => updateAtPath([...path, idx, "language"], e.target.value)}/>

                            <InputField
                                title={'File Name'}
                                className='flex flex-1'
                                value={ed.fileName || ""}
                                onChange={e => updateAtPath([...path, idx, "fileName"], e.target.value)}/>
                        </div>

                        <div className='px-5 mb-5'>
                            <CodeEditor
                                language={ed.language}
                                style={{width: "100%", height: "80px", fontFamily: "monospace"}}
                                value={ed.starterCode || ""}
                                onChange={(value) =>
                                    updateAtPath([...path, idx, "starterCode"], value)
                                }
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
